import { UnitsManagementConst } from '@featureModule/units-management/consts';

/**
 * Constants for the Facility sub-module within Units Management.
 * Provides route paths, translation keys, and API endpoint placeholders.
 */
export abstract class FacilityConst {

    /**
     * The display title for the Facility page.
     */
    public static readonly TITLE = 'Facility';

    /**
     * The i18n translation key for the Facility sub-module.
     */
    public static readonly TRANSLATE_KEY = UnitsManagementConst.CHILDREN.FACILITY.TRANSLATE_KEY();

    /**
     * The breadcrumb translation key for the Facility page.
     */
    public static readonly BREADCRUMB = UnitsManagementConst.CHILDREN.FACILITY.BREADCRUMB();

    /**
     * The URL route segment for the Facility page.
     */
    public static readonly ROUTE_PAGE = UnitsManagementConst.CHILDREN.FACILITY.ROUTE_PAGE;

    /**
     * The full absolute route link for the Facility page.
     */
    public static readonly ROUTE_LINK = UnitsManagementConst.CHILDREN.FACILITY.ROUTE_LINK();

    /**
     * The base API endpoint prefix for Facility-related requests.
     */
    public static readonly API_PREFIX_ENDPOINT = 'facilities';

    /**
     * Endpoint to retrieve the facility details.
     * @returns {string} GET endpoint for facility.
     */
    public static readonly GET_FACILITY_ENDPOINT = FacilityConst.API_PREFIX_ENDPOINT;

    /**
     * Endpoint to update a facility by ID.
     * @param id - The UUID of the facility.
     * @returns {string} PUT endpoint for the given facility.
     */
    public static readonly UPDATE_FACILITY_ENDPOINT = (id: string): string =>
        `${FacilityConst.API_PREFIX_ENDPOINT}/${id}`;

    /**
     * Endpoint to retrieve the list of facility types for the lookup dropdown.
     * @returns {string} GET endpoint for facility types.
     */
    public static readonly GET_FACILITY_TYPES_ENDPOINT = `${FacilityConst.API_PREFIX_ENDPOINT}/types`;

}
